import React from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import events from '../../events';
import eventTracker from '../../../../helpers/eventTracker';
import VimeoPlayer from '../../components/VimeoPlayer';

const LMCarousel = ({
  lmPageIndex,
  learning_module,
  itemPerPage,
  learnMoreClickHandler,
  setLmPageIndex
}) => {
  const videoEventTrackerHandler = (lesson, isStartingVideo) => {
    const lesson_oidx = learning_module.videos
      .findIndex((i) => i.coachable_id === lesson.coachable_id);
    const isLastLesson = lesson_oidx === learning_module.videos.length - 1;

    eventTracker(
      isStartingVideo ? events.DZ_LM_VIDEO_START : events.DZ_LM_VIDEO_END,
      {
        lesson_oidx,
        lm_Id: lesson.campaign_id,
        activity_id: lesson.coachable_id,
        lesson_last: isLastLesson
      }
    );
  };

  return (
    <>
      <CarouselContainer key={lmPageIndex}>
        {learning_module.videos.slice(lmPageIndex * itemPerPage,
          itemPerPage * (lmPageIndex + 1))
          .map((item, index) => (
            <Card key={item.video_link}>
              <CardVideoWrapper>
                <VimeoPlayer
                  onVideoStart={() => videoEventTrackerHandler(item, true)}
                  onVideoEnded={() => videoEventTrackerHandler(item, false)}
                  videoId={item.video_link}
                />
              </CardVideoWrapper>
              <CardSummary>
                {item.message.replace(/<[^>]+>/g, '')}
              </CardSummary>
              {item.message.length > 250 && (
                <LearnMore
                  aria-labelledby={item.title}
                  aria-label={`Learn more about ${item.title}`}
                  onClick={() => learnMoreClickHandler(index + lmPageIndex * itemPerPage)}
                >
                  {_('homePage.learn_more')}

                </LearnMore>
              )}
            </Card>
          ))}
      </CarouselContainer>
      <BulletCarousel>
        {[...Array(Math.ceil(learning_module.videos.length / itemPerPage))]
          .map((_, bulletIndex) => (
            <HorizontalBullet
              onClick={() => setLmPageIndex(bulletIndex)}
              isCurrentSlide={lmPageIndex === bulletIndex}
            />
          ))}
      </BulletCarousel>
      <LeftArrow
        disabled={lmPageIndex === 0}
        onClick={() => setLmPageIndex((prevState) => prevState - 1)}
        aria-label="Previous"
      >
        &#8678;
      </LeftArrow>
      <RightArrow
        disabled={lmPageIndex === Math.ceil(learning_module.videos.length / itemPerPage) - 1}
        onClick={() => setLmPageIndex((prevState) => prevState + 1)}
        aria-label="Next"
      >
        &#8680;
      </RightArrow>
    </>
  );
};

export default LMCarousel;

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const CarouselContainer = styled.div`
  padding: 0 15px; 
  display: flex;
  justify-content: flex-start;
  column-gap: 26px;
  min-height: 250px;
`;
const Card = styled.div`
  position: relative;
  overflow: hidden;
  width: 50%;
`;

const CardVideoWrapper = styled.div`
  /* height: 180px; */
  overflow: hidden;
  margin-bottom: 15px;
  animation: ${OpacityAnimation} 0.5s;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-delay: 0.6s;
`;

const BulletCarousel = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;
const CardSummary = styled.div`
  width: 100%;
  color: #404040;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  line-clamp: 5;
  -webkit-box-orient: vertical;

  & p:first-child {
    margin-top: 0;
  }
`;
const LearnMore = styled.button`
background-color: transparent;
  border: none;
  position: absolute;
  bottom: -2px;
  right: 0;
  font-size: 14px !important;
  color: #387AA8 !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
  text-transform: uppercase;
  padding-left: 20px;
  background-image: linear-gradient(to right, rgba(255,255,255,0.2) 0%, white 15%, white 100%);
  cursor: pointer;
  margin: 0;
  padding-top: 3px;

`;

const HorizontalBullet = styled.div`
  height: 10px;
  margin: 10px 3px;
  background-color: ${({ isCurrentSlide }) => (isCurrentSlide ? '#76CBC4' : 'rgba(0, 0, 0, 0.06)')} ;
  width: ${({ isCurrentSlide }) => (isCurrentSlide ? '20px' : '10px')} ;
  border-radius: 10px;
  cursor: pointer;
  transition: width .1s;
`;

const LeftArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: absolute;
  left: 2px;
  top: 45%;
  margin-top: 17px;
  transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  padding: 0;
  line-height: normal;
  background-color: #269EE2;

  &:hover {
    opacity: 0.95 !important;
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;

const RightArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: absolute;
  right: 2px;
  top: 45%;
  margin-top: 17px;
  transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  padding: 0;
  line-height: normal;
  background-color: #269EE2;

  &:hover {
    opacity: 0.95 !important;
    border-radius: 50%;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
    opacity: 0.3 !important;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
